import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const timer = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    boundaryEventId: z
      .string()
      .describe('The boundary event that created this timer'),

    interrupting: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this boundary event cancels the parent activity'),

    fireAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this timer will trigger'),

    status: z
      .enum(['Active', 'Paused', 'Triggered', 'Complete', 'Canceled'])
      .nullable()
      .optional()
      .describe('Current state of this timer'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    token: belongsTo('Token'),
  })
  .describe('A scheduled timer that will trigger at a specific time')
  .as('Timer');

export { timer as timerSchema };
